import React from "react";

import { Doc } from "affinityUI/structures/doc";
import { Layout } from "affinityUI/structures/layout";

import {
  AddPatientSection,
  IntroductionSection,
  PatientInformationSection,
  PatientManagementSection,
  PatientTrainingSection,
  RegistrationSection,
  RequestDeviceSection,
  ResultsCardSection,
  ReviewResultsSection,
  SupportSection,
  WithdrawDeviceSection,
} from "../../../views/support/instructions";

import entiaLibertyJourney from "./assets/User journey.png";
export const InstructionsPage = () => {
  return (
    <Layout title="Dashboard Instructions" showBackBtn backLink=".." actions="Updated: 21st February 2023">
      <Doc.Illustration src={entiaLibertyJourney} />
      <Doc>
        <IntroductionSection />
        <RegistrationSection />
        <PatientManagementSection />
        <AddPatientSection />
        <PatientInformationSection />
        <RequestDeviceSection />
        <PatientTrainingSection />
        <ReviewResultsSection />
        <ResultsCardSection />
        <WithdrawDeviceSection />
        <SupportSection />
      </Doc>
    </Layout>
  );
};
